"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Picross = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const lodash_1 = __importDefault(require("lodash"));
const react_1 = require("react");
const react_bootstrap_1 = require("react-bootstrap");
require("./Picross.scss");
const minigame_1 = require("../typeDefs/minigame");
var ClickState;
(function (ClickState) {
    ClickState[ClickState["noGuess"] = 0] = "noGuess";
    ClickState[ClickState["markGuess"] = 1] = "markGuess";
    ClickState[ClickState["markEmpty"] = 2] = "markEmpty";
})(ClickState || (ClickState = {}));
function Picross({ difficulty, onSolve, giftRepr, onCancel, }) {
    const size = (0, react_1.useMemo)(() => {
        switch (difficulty) {
            case minigame_1.Difficulty.Easy: return 10;
            case minigame_1.Difficulty.Medium: return 15;
            case minigame_1.Difficulty.Hard: return 20;
        }
    }, [difficulty]);
    const [hintsX, hintsY] = (0, react_1.useMemo)(() => generateBoard(size, size), []);
    const [mouse, setMouse] = (0, react_1.useState)([-1, -1]);
    const [mouseX, mouseY] = mouse;
    const [selected, setSelected] = (0, react_1.useState)([-1, -1]);
    const [selectedX, selectedY] = selected;
    const [state, setState] = (0, react_1.useState)((0, react_1.useMemo)(() => generateEmptyState(size, size), []));
    const [clickState, setClickState] = (0, react_1.useState)(0);
    const [stateXHints, stateYHints, hasBeenSolved] = (0, react_1.useMemo)(() => {
        const xhint = getHints(redim(state));
        const yhint = getHints(state);
        const solved = lodash_1.default.isEqual(hintsX, xhint) && lodash_1.default.isEqual(hintsY, yhint);
        return [xhint, yhint, solved];
    }, [state]);
    (0, react_1.useEffect)(() => {
        if (hasBeenSolved) {
            setClickState(0);
            setMouse([-1, -1]);
            setSelected([-1, -1]);
        }
    });
    const [selectedRows, selectedColumns] = (0, react_1.useMemo)(() => {
        const selectedRows = [mouseY];
        const selectedColumns = [mouseX];
        if (selectedX !== -1) {
            const minX = Math.min(mouseX, selectedX);
            const maxX = Math.max(mouseX, selectedX);
            for (let x = minX; x <= maxX; x++) {
                selectedColumns.push(x);
            }
        }
        if (selectedY !== -1) {
            const minY = Math.min(mouseY, selectedY);
            const maxY = Math.max(mouseY, selectedY);
            for (let y = minY; y <= maxY; y++) {
                selectedRows.push(y);
            }
        }
        return [selectedRows, selectedColumns];
    }, [mouseX, mouseY, selectedX, selectedY]);
    const onClick = (0, react_1.useCallback)((x, y, which) => {
        setClickState(which);
        setSelected([x, y]);
    }, []);
    const onMouseUp = (0, react_1.useCallback)((x, y) => {
        if (clickState === ClickState.noGuess)
            return;
        const newState = lodash_1.default.cloneDeep(state);
        const rows = [...new Set(selectedRows)];
        const cols = [...new Set(selectedColumns)];
        const shouldFlip = product(rows, cols).every(([x, y]) => newState[x][y] === clickState);
        for (let i of rows) {
            for (let j of cols) {
                if (newState[i][j] === clickState && shouldFlip) {
                    newState[i][j] = ClickState.noGuess;
                }
                else {
                    newState[i][j] = clickState;
                }
            }
        }
        setSelected([-1, -1]);
        setClickState(ClickState.noGuess);
        setState(newState);
    }, [state, selectedRows, selectedColumns]);
    const onMouseOver = (0, react_1.useCallback)((x, y) => {
        setMouse([x, y]);
    }, []);
    return ((0, jsx_runtime_1.jsxs)(react_bootstrap_1.Modal, { onHide: onCancel, show: true, size: 'lg', children: [(0, jsx_runtime_1.jsx)(react_bootstrap_1.Modal.Header, { closeButton: true, children: (0, jsx_runtime_1.jsx)(react_bootstrap_1.Modal.Title, { children: "Picross" }) }), (0, jsx_runtime_1.jsxs)(react_bootstrap_1.Modal.Body, { children: [giftRepr && ((0, jsx_runtime_1.jsxs)("span", { children: ["Play to win: ", giftRepr] })), (0, jsx_runtime_1.jsx)(react_bootstrap_1.Table, { className: 'picross noselect', bordered: true, children: (0, jsx_runtime_1.jsxs)("tbody", { children: [(0, jsx_runtime_1.jsxs)("tr", { className: 'vertical-hints', children: [(0, jsx_runtime_1.jsx)("td", {}), hintsX.map((h, i) => {
                                            const isColSolved = lodash_1.default.isEqual(h, stateXHints[i]) ? 'solved-header' : '';
                                            const crossSelect = selectedColumns.includes(i) ? 'cross-select' : '';
                                            return ((0, jsx_runtime_1.jsx)("td", { className: `${isColSolved} ${crossSelect}`, children: (0, jsx_runtime_1.jsx)("pre", { children: h.map((x, j) => ((0, jsx_runtime_1.jsxs)("span", { className: x === stateXHints[i][j] ? 'hint complete' : 'hint', children: [x, "\n"] }, j))) }) }, i));
                                        })] }), hintsY.map((h, i) => ((0, jsx_runtime_1.jsx)(BoardRow, { y: i, hints: h, state: state[i], stateHints: stateYHints[i], isRowSelected: selectedRows.includes(i), selectedColumns: selectedColumns, onClick: onClick, onMouseUp: onMouseUp, onMouseOver: onMouseOver, isSolved: hasBeenSolved, clickState: clickState }, i)))] }) })] }), (0, jsx_runtime_1.jsx)(react_bootstrap_1.Modal.Footer, { children: hasBeenSolved && ((0, jsx_runtime_1.jsxs)(react_bootstrap_1.Button, { variant: 'primary', onClick: onSolve, children: ["Redeem Gift: ", giftRepr] })) })] }));
}
exports.Picross = Picross;
function BoardRow({ y, hints, state, stateHints, isRowSelected, selectedColumns, onClick, onMouseUp, onMouseOver, isSolved, clickState, }) {
    const handleClick = (e, x) => {
        if (onClick) {
            if (e.type === 'mousedown') {
                onClick(x, y, e.button === 0 ? ClickState.markGuess : ClickState.markEmpty);
            }
            else if (e.type === 'contextmenu') {
                onMouseUp(x, y);
            }
        }
        e.stopPropagation();
        e.preventDefault();
    };
    const isRowSolved = lodash_1.default.isEqual(hints, stateHints) ? 'solved-header' : '';
    const crossSelect = isRowSelected ? 'cross-select' : '';
    return ((0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsx)("td", { className: `${isRowSolved} ${crossSelect}`, children: (0, jsx_runtime_1.jsx)("pre", { children: hints.map((x, j) => ((0, jsx_runtime_1.jsx)("span", { className: x === stateHints[j] ? 'hint complete' : 'hint', children: x }, j))) }) }), state.map((v, i) => {
                let color = 'no-mark';
                let selected = '';
                let highlight = '';
                switch (v) {
                    case ClickState.markGuess: {
                        color = isSolved ? 'solved-square' : 'mark-guess';
                        break;
                    }
                    case ClickState.markEmpty: {
                        color = 'mark-empty';
                        break;
                    }
                }
                if (selectedColumns.includes(i) && isRowSelected) {
                    switch (clickState) {
                        case ClickState.markGuess: {
                            selected = 'will-select';
                            break;
                        }
                        case ClickState.markEmpty: {
                            selected = 'will-empty';
                            break;
                        }
                    }
                }
                if (!selected && (selectedColumns.includes(i) || isRowSelected))
                    highlight = 'cross-select';
                const mouseProps = {
                    onMouseDown: (e) => handleClick(e, i),
                    onContextMenu: (e) => handleClick(e, i),
                    onMouseUp: (e) => onMouseUp(i, y),
                    onMouseOver: (e) => onMouseOver(i, y),
                };
                return ((0, jsx_runtime_1.jsx)("td", { className: `${color} ${selected} ${highlight} picross-square`, ...(isSolved ? {} : mouseProps), children: "\u00A0" }, i));
            })] }));
}
function generateEmptyState(width, height) {
    const board = Array(width);
    for (let i = 0; i < width; i++) {
        board[i] = Array(height);
        for (let j = 0; j < height; j++) {
            board[i][j] = 0;
        }
    }
    return board;
}
function generateBoard(width, height) {
    const board = generateEmptyState(width, height);
    for (let i = 0; i < width; i++) {
        for (let j = 0; j < height; j++) {
            board[i][j] = Math.floor(Math.random() * 2);
        }
    }
    return [getHints(redim(board)), getHints(board)];
}
function redim(arr) {
    return lodash_1.default.zip(...arr);
}
function getHints(board) {
    const hints = [];
    for (const row of board) {
        let streak = 0;
        const a = [];
        hints.push(a);
        for (const item of row) {
            if (item === ClickState.markGuess) {
                streak += 1;
            }
            else if (streak > 0) {
                a.push(streak);
                streak = 0;
            }
        }
        if (streak > 0) {
            a.push(streak);
        }
    }
    return hints;
}
function product(a1, a2) {
    const results = [];
    for (const x of a1) {
        for (const y of a2) {
            results.push([x, y]);
        }
    }
    return results;
}
